import { CmsSignupIntentOption } from 'signup-constants/signupData/CmsOption';
import { FlowManager } from '../../flow-management/FlowManager';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { Data } from '../../signup-data/DATA';
import { Step } from '../../views/Step';
import { updateFlow } from '../../store/flow/action-creators';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
export const BranchCmsBusinessMaturity = {
  name: 'BranchCmsBusinessMaturity',
  stateCheck: state => {
    const cmsSignupIntentValue = getSignupDataValue(state, Data.CmsSignupIntent);
    return cmsSignupIntentValue === CmsSignupIntentOption.Personal;
  },
  rebuildFlow: (flow, state, dispatch) => {
    const currentFlowSteps = getFlowSteps();
    const postAccountCreationSteps = FlowManager.removeSteps(Step.CmsBusinessMaturity)(currentFlowSteps.postAccountCreation);
    dispatch(updateFlow(currentFlowSteps.preVerification, currentFlowSteps.postVerification, postAccountCreationSteps, currentFlowSteps.postExistingAccountSelection));
    return FlowManager.removeSteps(Step.CmsBusinessMaturity)(flow);
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};